"use client";

import Link from "@/components/ui/Link";
import { useLang } from "@/components/ui/lang-context";
import { useUi } from "@/components/ui/use-ui";
import { useCoinBalance } from "@/lib/coins-badge";
import { SweetCoin } from "./SweetCoin";

// The header's coin (components/coins/HeaderCoins.tsx): the Sweet Coin and the balance, to the coins on the
// Premium page. It starts from the balance the page was served with and follows lib/coins-badge.ts after that
// (every minute, and at once when coins are bought, spent or collected).

/** 1,234 in full up to 9,999, then 12.3K, 1.2M (in the page's language). */
function short(n: number, lang: string) {
  return new Intl.NumberFormat(lang, n >= 10_000 ? { notation: "compact", maximumFractionDigits: 1 } : {}).format(n);
}

export function CoinBalance({ initial }: { initial: number }) {
  const t = useUi();
  const lang = useLang();
  const balance = useCoinBalance() ?? initial;
  const full = new Intl.NumberFormat(lang).format(balance);
  return (
    <Link
      href="/subscription#coins"
      aria-label={`${t.nav.coins}: ${full}`}
      title={`${t.nav.coins}: ${full}`}
      className="chip flex h-9 shrink-0 items-center gap-1 rounded-full pl-1 pr-2 text-[13.5px] font-medium tabular-nums text-fg hover:text-brand-soft min-[360px]:mr-1 min-[360px]:gap-1.5 min-[360px]:pr-2.5"
    >
      <SweetCoin size={24} />
      <span aria-hidden>{short(balance, lang)}</span>
    </Link>
  );
}
